
<template>
  <div>
    <dialog-edit-company></dialog-edit-company>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditCompany from '../../../components/admin/company/DialogEditCompany.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ShowCompanyPage',
  //mixins: [ validations ],
  components: {
    DialogEditCompany
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>